import React from 'react';
import uniq from 'lodash/uniq';
import { v4 as uuid } from 'uuid';
import { ProgramTypeAndSubTypeLabel } from 'utils/enums';

import { getStateLabel } from 'helpers/forms';
import { formatUTCDate } from 'utils/dateTime';

// eslint-disable-next-line import/prefer-default-export
export const tableColumns = [
  {
    id: 'userRole',
    label: 'Role',
    headerStyle: { width: '10%' },
    override: ({ roleOnVerification }) => roleOnVerification,
  },
  {
    id: 'siteName',
    label: 'Site Name',
    headerStyle: { width: '34%' },
    override: ({ siteName }) => siteName.split(', ').map((s) => <div key={uuid()}>{s}</div>),
  },
  {
    id: 'state',
    label: 'Review Status',
    headerStyle: { width: '14%' },
    override: ({ state }) => getStateLabel(state),
  },
  {
    id: 'programType',
    label: 'Program type',
    headerStyle: { width: '14%' },
    override: ({ applicationType }) => ProgramTypeAndSubTypeLabel[applicationType] || applicationType,
  },

  {
    id: 'siteReviewers',
    label: 'Site Reviewers',
    headerStyle: { width: '18%' },
    nonSortable: true,
    override: ({ siteReviewers }) => siteReviewers
      && uniq(siteReviewers.split(', ')).map((sr) => <div key={uuid()}>{sr}</div>),
  },
  {
    id: 'siteVisitAt',
    label: 'Site Visit',
    headerStyle: { width: '10%' },
    override: ({ siteVisitAt }) => formatUTCDate(siteVisitAt),
  },
];
